import { render, staticRenderFns } from "./goback.vue?vue&type=template&id=65dd7950&scoped=true&"
import script from "./goback.vue?vue&type=script&lang=js&"
export * from "./goback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd7950",
  null
  
)

export default component.exports